import { create } from 'zustand';

interface OnboardingState {
  currentStep: number;
  answers: {
    goal?: string;
    experience?: string;
    challenge?: string;
    outcome?: string;
    aiFamiliarity?: string;
  };
  email?: string;
  phone?: string;
  selectedPlan?: string;
  setCurrentStep: (step: number) => void;
  setAnswer: (key: keyof OnboardingState['answers'], value: string) => void;
  setEmail: (email: string) => void;
  setPhone: (phone: string) => void;
  setSelectedPlan: (plan: string) => void;
  nextStep: () => void;
  prevStep: () => void;
  resetFlow: () => void;
}

export const useOnboardingStore = create<OnboardingState>((set, get) => ({
  currentStep: 1,
  answers: {},
  email: undefined,
  phone: undefined,
  selectedPlan: '2-week',
  setCurrentStep: (step) => set({ currentStep: step }),
  setAnswer: (key, value) => set((state) => ({
    answers: { ...state.answers, [key]: value }
  })),
  setEmail: (email) => set({ email }),
  setPhone: (phone) => set({ phone }),
  setSelectedPlan: (plan) => set({ selectedPlan: plan }),
  nextStep: () => set((state) => {
    console.log('nextStep called: moving from step', state.currentStep, 'to step', state.currentStep + 1);
    return { currentStep: state.currentStep + 1 };
  }),
  prevStep: () => set((state) => ({ currentStep: Math.max(1, state.currentStep - 1) })),
  resetFlow: () => set({ currentStep: 1, answers: {}, email: undefined, phone: undefined, selectedPlan: '2-week' }),
}));